module.exports = __webpack_public_path__ + "static/media/vote-nay.972aa134.svg";